/**
 * Contract between the reception label screen and guía emission: goods received and
 * labelled before the guía exist carry their lote to the guía, which links the same
 * physical labels on the server (etiqueta_lote_id) instead of creating new ones.
 */

const DEFAULT_DESCRIPCION = 'Mercadería recibida';
const number = (value) => Number(value) || 0;

/** Keeps only the fields of the GraphQL EtiquetaItemInput. */
export function toEtiquetaItemInput(item) {
  return {
    remito: item.remito,
    bultos: item.bultos,
    descripcion: item.descripcion,
    kReal: item.kReal,
    kilos: item.kilos,
    mts3: item.mts3,
  };
}

export function buildEtiquetaOrigen({ labels, items, remitente, destinatario }) {
  const first = labels?.[0];
  if (!first?.loteId) return null;
  return {
    loteId: Number(first.loteId),
    codigoLote: first.codigoEtiqueta,
    bultos: number(first.bultosTotal) || labels.length,
    remitenteClienteId: remitente?.clienteId ?? null,
    remitenteDomicilio: remitente?.direccion || '',
    destinatarioClienteId: destinatario?.clienteId ?? null,
    destinatarioDomicilio: destinatario?.direccion || '',
    destinatarioLocalidadId: destinatario?.localidadId ?? null,
    remitos: (items || []).map((item) => ({
      numero_remito: String(item.remito || '').trim(),
      bultos: number(item.bultos),
      kg_reales: number(item.kg_reales ?? item.kilos),
      m3: number(item.m3 ?? item.mts3),
      kg_aforado: number(item.kg_aforado),
      valor_declarado: number(item.valor_declarado),
      descripcion: String(item.descripcion || '').trim() || DEFAULT_DESCRIPCION,
    })),
  };
}

export function mapEtiquetaOrigenToGuia(origen) {
  if (!origen?.loteId) return null;
  const asId = (value) => (value == null || value === '' ? '' : String(value));
  return {
    values: {
      remitente_id: asId(origen.remitenteClienteId),
      destinatario_id: asId(origen.destinatarioClienteId),
      domicilio_remitente: origen.remitenteDomicilio || '',
      domicilio_destinatario: origen.destinatarioDomicilio || '',
      localidad_destino_id: asId(origen.destinatarioLocalidadId),
      etiqueta_lote_id: String(origen.loteId),
    },
    observacion: `Generada desde la recepción con etiquetas ${origen.codigoLote} (${origen.bultos} bultos).`,
    remitos: origen.remitos || [],
  };
}
